export const DYNAMIC_FORM = 'dynamic-form';
export const AUDIT_DIFF_MODAL = 'audit-diff-modal';
export const FORM_HISTORY_MODAL = 'form-history-modal';
